import React, { Component } from 'react';
import { Common } from '../../core/common';
import { IHomePageBoxVirtualClassProps } from '../../models/components/homepage-box-virtualclass';
import { IAppState } from '../../models/action/core';
import { connect } from 'react-redux';
import { Log } from 'ng2-logger';
import { IMyVirtualClass } from '../../models/action/virtualClass';
import { SecureImage } from '../../components/core/secureImage';
import { Redirect } from 'react-router-dom';
import Translator from '../../core/i18n';
import Loading from '../loading/loading';
import * as Actions from '../../store/actions/profile';
import { IProfileProps } from '../../models/pages/profile';
import ContentLoader from 'react-content-loader';
import { IPreference } from '../../models/action/profile';
import ShowAllButton from '../show-all-button/main';

const T = Translator.create();
const _logger = Log.create('Virtual Class Box');
let _common: Common;

export class CVirtualClass extends Component<IHomePageBoxVirtualClassProps & IProfileProps, any, {}> {
    state = {
        redirect: false,
        redirectUrl: '/',
        boxItems: ['0', '1', '2', '3', '4', '5', '6', '7', '8'],
        boxItemsVisual: [false, false, false, false, false, false],
        boxCount: 0
    };

    constructor(props: any) {
        super(props);
        _common = new Common();
    }
    
    public handleChange = () => {
            const { userPreferences, dispatch } = this.props;
            const { boxItems, boxItemsVisual } = this.state;
    
            const updateBoxItemsVisual = (items: string[]) => {
                items.forEach(item => {
                    boxItemsVisual[parseInt(item, 10)] = true;
                });
            };
    
            const updatePreferences = (items: string[]) => {
                const preferencesValue = items.toString();
                const preferenceData = {
                    preferences: [{ name: 'home.index.boxallowed', value: preferencesValue }]
                };
                dispatch(Actions.addOrUpdatePreferencesAction(preferenceData));
            };
    
            if (userPreferences && userPreferences.length > 0) {
                const preference = userPreferences.find((pref: any) => pref.name === 'home.index.boxallowed');
                if (preference && preference.value) {
                    const updatedBoxItems = preference.value.split(',').filter(item => item !== '0');
                    this.setState({ boxItems: updatedBoxItems });
                    updateBoxItemsVisual(updatedBoxItems);
                    updatePreferences(updatedBoxItems);
                }
            } else {
                const updatedBoxItems = boxItems.filter(item => item !== '0');
                this.setState({ boxItems: updatedBoxItems });
                updateBoxItemsVisual(updatedBoxItems);
                updatePreferences(updatedBoxItems);
            }
    };

    onClick = (event: any) => {
        if (event && event.currentTarget) {
            this.setState({redirect: true, redirectUrl: event.currentTarget.getAttribute('data-redirectLink')});
        }
    }

    componentDidMount () {
        if (this.props.userPreferences!.length > 0) {
            if (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxcount')) {
                this.setState({
                    boxCount: (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxcount') as IPreference).value
                });
            }
        }
    }

    public render() {
        const initialFormValues = {
            ...this.props.profileData,
            userPreferences: this.props.userPreferences,
            handleChange: this.handleChange
        };
        const loadingSpaces = 70;
        const loadingSizes = this.state.boxCount === 2 ? '0 0 540 300' : '0 0 350 300';
        const loadingWidth = this.state.boxCount === 2 ? 540 : 350;
        if(this.state.redirect) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/' + this.state.redirectUrl} />;
        }
        return (
            <div className="white-box ">
                <div className="d-flex justify-content-between white-box-header">
                    <div>
                        <span className='lms-header-medium ' tabIndex={0}>{T.t('r_home_index_box_virtual_class')}<span className='badge badge-pill badge-light py-1 px-2' style={{marginInlineStart: "0.5rem"}}  tabIndex={0}>{this.props.myVirtualClass ? this.props.myVirtualClass.length : ''}</span></span>
                    </div>
                    <div className="align-self-center">
                        <i
                            className="material-icons mr-2 align-middle"
                            onClick={this.handleChange}
                            style={{ cursor: 'pointer' }}
                        >
                            visibility
                            </i>
                        <ShowAllButton redirectUrl='/u/activities-dashboard?activityType=VirtualClass'/>
                    </div>
                </div>
                <Loading spinnerId={'getHomeBoxVirtualClass'}>
                    <div style={{ backgroundColor: '#fbfaf6' }}>
                        <ContentLoader
                            speed={2}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                            viewBox={loadingSizes}
                            style={{ width: '100%' }}
                        >
                            <rect x="85" y="24" rx="3" ry="3" width="100" height="8" />
                            <rect x="85" y="44" rx="3" ry="3" width="150" height="7" />
                            <circle cx="45" cy="45" r="30" />
                            <rect x="85" y="60" rx="3" ry="3" width="70" height="7" />

                            <rect x="85" y={24 + loadingSpaces} rx="3" ry="3" width="100" height="8" />
                            <rect x="85" y={44 + loadingSpaces} rx="3" ry="3" width="150" height="7" />
                            <circle cx="45" cy={45 + loadingSpaces} r="30" />
                            <rect x="85" y={60 + loadingSpaces} rx="3" ry="3" width="70" height="7" />

                            <rect x="85" y={24 + loadingSpaces * 2} rx="3" ry="3" width="100" height="8" />
                            <rect x="85" y={44 + loadingSpaces * 2} rx="3" ry="3" width="150" height="7" />
                            <circle cx="45" cy={45 + loadingSpaces * 2} r="30" />
                            <rect x="85" y={60 + loadingSpaces * 2} rx="3" ry="3" width="70" height="7" />

                            <rect x="85" y={24 + loadingSpaces * 3} rx="3" ry="3" width="100" height="8" />
                            <rect x="85" y={44 + loadingSpaces * 3} rx="3" ry="3" width="150" height="7" />
                            <circle cx="45" cy={45 + loadingSpaces * 3} r="30" />
                            <rect x="85" y={60 + loadingSpaces * 3} rx="3" ry="3" width="70" height="7" />

                            <rect x="85" y={24 + loadingSpaces * 4} rx="3" ry="3" width="100" height="8" />
                            <rect x="85" y={44 + loadingSpaces * 4} rx="3" ry="3" width="150" height="7" />
                            <circle cx="45" cy={45 + loadingSpaces * 4} r="30" />
                            <rect x="85" y={60 + loadingSpaces * 4} rx="3" ry="3" width="70" height="7" />
                        </ContentLoader>
                    </div>
                </Loading>
                <div id="getHomeBoxVirtualClass_Content" className="white-box-body">
                    {this.props.myVirtualClass && this.props.myVirtualClass.length > 0 ?
                        this.props.myVirtualClass.map((virtualClass: IMyVirtualClass, key: any) => {
                            return <div className="media mb-3 " key={key}>
                                <SecureImage style={{borderRadius: 100}} class={'userProfile mr-3'} imageUrl={virtualClass.userAvatarPath}  />
                                <div className="media-body mb-1">
                                    <h5 className="mt-0 homebox-clickable-item" tabIndex={0}>
                                        <button style={{background:'none', border:'none', textAlign:'left', paddingLeft:"0px", fontWeight:'inherit'}} className="homebox-clickable-item" data-redirectLink={'u/course?classId=' + virtualClass.classId + '&activityId=' + virtualClass.courseId + '&type=1' +'&actid=' + virtualClass.activityId + '&weekorunitid=' + virtualClass.termWeekId} onClick={this.onClick}>{virtualClass.name}</button>
                                    </h5>
                                    <span className="d-block mb-1" tabIndex={0}>{virtualClass.teacherFullName}</span>
                                    {virtualClass.actualStartTime ? this.props.diffVirtualClassDate(virtualClass.actualStartTime, virtualClass.actualEndTime, virtualClass.serverTime, "virtualClass") : ''}
                                </div>
                            </div>;
                        })
                        : (
                            <p tabIndex={0}>{T.t('r_home_box_virtual_class_not_found')}</p>
                        )
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IHomePageBoxVirtualClassProps): IHomePageBoxVirtualClassProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IHomePageBoxVirtualClassProps = Object.assign({}, ownProps, {
        myVirtualClass: state.coursePage.myVirtualClass,
        userPreferences: state.profile.userPreferences.preferences
    });

    return newProps;
};


const VirtualClass = connect(
    mapStateToProps
)(CVirtualClass);

export default VirtualClass;
